<template>
    <div class="cms-container mb-4">
        <ToastCMS ref="toast" />
        <div v-if="showPreviewModal" class="preview-modal w-100 h-100 d-flex align-items-center justify-content-center"
            @click.self="closePreviewImage">
            <div class="d-block-align-items-center justify-content-center w-100 mx-3">
                <div class="modal-content bg-transparent position-relative border-0">
                    <button class="close-btn position-fixed text-white bg-transparent border-0"
                        @click="closePreviewImage">&times;</button>

                    <div class="d-flex justify-content-between align-items-center border-0">
                        <img :src="previewImages[currentPreviewIndex]" alt="Preview Image">
                    </div>
                </div>

                <div v-if="previewImages.length > 1" class="text-center mt-3">
                    <span class="text-white">Image {{ currentPreviewIndex + 1 }} of {{ previewImages.length }}</span>
                </div>
            </div>
        </div>
        <div class="sticky-controls">
            <div class="company-header d-flex align-items-center justify-content-between px-3">
                <div class="desc-header text-dark">Company Description</div>
                <button type="button" @click="clearText" class="vmc-bg-prime-6 text-white rounded border-0 px-2 py-1">
                    Clear Inputs
                </button>
            </div>
        </div>
        <form action="" id="thecompany" @submit.prevent="saveAllChanges">
            <div class="grid d-block d-sm-flex px-3">
                <div class="w-100 mt-3">
                    <label class="text-dark">Company Description</label>
                    <textarea rows="3" class="text-dark w-100" v-model="TCdescription"></textarea>
                </div>
                <div class="w-100 mt-3">
                    <label class="text-dark">Why Veritas Was Established</label>
                    <textarea rows="3" class="text-dark w-100" v-model="whyVeritas"></textarea>
                </div>
            </div>
            <div class="grid d-block d-sm-flex px-3">
                <div class="w-100 mt-3">
                    <label class="text-dark">Quality Crew Recruitment</label>
                    <textarea rows="3" class="text-dark w-100" v-model="qualityCrewRecruitment"></textarea>
                </div>
                <div class="w-100 mt-3">
                    <label class="text-dark">Mission Statement</label>
                    <textarea rows="3" class="text-dark w-100" v-model="missionStatement"></textarea>
                </div>
            </div>
            <div class="grid d-block d-sm-flex px-3">
                <div class="w-100 mt-3">
                    <label class="text-dark">Core Values - Honesty</label>
                    <textarea rows="3" class="text-dark w-100" v-model="coreValuesHonesty"></textarea>
                </div>
                <div class="w-100 mt-3">
                    <label class="text-dark">Core Values - Integrity</label>
                    <textarea rows="3" class="text-dark w-100" v-model="coreValuesIntegrity"></textarea>
                </div>
                <div class="w-100 mt-3">
                    <label class="text-dark">Core Values - Quality</label>
                    <textarea rows="3" class="text-dark w-100" v-model="coreValuesQualityService"></textarea>
                </div>
            </div>
            <div class="grid d-block d-sm-flex px-3">
                <div class="w-100 mt-3">
                    <label class="text-dark">History Text</label>
                    <textarea rows="3" class="text-dark w-100" v-model="history"></textarea>
                </div>
            </div>
            <div class="grid d-block d-sm-flex px-3">
                <div class="w-100 mt-3">
                    <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                        <span class="logo-number text-dark" style="font-weight:600;">
                            Company Logo
                        </span>
                        <button type="button" @click="previewImage('aboutOfficeLogo')"
                            class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                            View
                        </button>
                    </div>
                    <div style="height:200px; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;"
                        class="mt-2">
                        <img v-if="images.aboutOfficeLogo" :src="images.aboutOfficeLogo"
                            style="height:100%; width:100%; object-fit:contain;" />
                        <template v-else>
                            <input type="file" id="upload-companylogo-img" accept="image/png, image/jpeg, image/jpg"
                                hidden @change="(e) => onImageChange(e, 'aboutOfficeLogo')">
                            <label for="upload-companylogo-img"
                                class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                style="cursor:pointer;">
                                <i class="material-symbols-outlined">upload</i>
                                <span>Upload Photo</span>
                            </label>
                        </template>
                    </div>
                    <button @click="resetImage('aboutOfficeLogo')" type="button"
                        class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                        Remove Photo
                    </button>
                </div>
                <div class="w-100 mt-3">
                    <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                        <span class="logo-number text-dark" style="font-weight:600;">
                            Quality Crew Background
                        </span>
                        <button type="button" @click="previewImage('aboutQualityCrewBg')"
                            class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                            View
                        </button>
                    </div>
                    <div style="height:200px; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;"
                        class="mt-2">
                        <img v-if="images.aboutQualityCrewBg" :src="images.aboutQualityCrewBg" alt="Slide Image"
                            style="height:100%; width:100%; object-fit:contain;">
                        <template v-else>
                            <input type="file" id="upload-qualitycrew-img" accept="image/png, image/jpeg, image/jpg"
                                hidden @change="(e) => onImageChange(e, 'aboutQualityCrewBg')">
                            <label for="upload-qualitycrew-img"
                                class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                style="cursor:pointer;">
                                <i class="material-symbols-outlined">upload</i>
                                <span>Upload Photo</span>
                            </label>
                        </template>
                    </div>
                    <button @click="resetImage('aboutQualityCrewBg')" type="button"
                        class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                        Remove Photo
                    </button>
                </div>
            </div>
            <div class="grid d-block d-sm-flex px-3">
                <div class="w-100 mt-3">
                    <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                        <span class="logo-number text-dark" style="font-weight:600;">
                            History
                        </span>
                        <button type="button" @click="previewImage('aboutTowerImg')"
                            class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                            View
                        </button>
                    </div>
                    <div style="height:200px; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;"
                        class="mt-2">
                        <img v-if="images.aboutTowerImg" :src="images.aboutTowerImg" alt="Slide Image"
                            style="height:100%; width:100%; object-fit:contain;">
                        <template v-else>
                            <input type="file" id="upload-history-img" accept="image/png, image/jpeg, image/jpg" hidden
                                @change="(e) => onImageChange(e, 'aboutTowerImg')">
                            <label for="upload-history-img"
                                class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                style="cursor:pointer;">
                                <i class="material-symbols-outlined">upload</i>
                                <span>Upload Photo</span>
                            </label>
                        </template>
                    </div>
                    <button @click="resetImage('aboutTowerImg')" type="button"
                        class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                        Remove Photo
                    </button>
                </div>
                <div class="w-100 mt-3">
                    <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                        <span class="logo-number text-dark" style="font-weight:600;">
                            Organizational Chart
                        </span>
                        <button type="button" @click="previewImage('orgChartImg')"
                            class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                            View
                        </button>
                    </div>
                    <div style="height:200px; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;"
                        class="mt-2">
                        <img v-if="images.orgChartImg" :src="images.orgChartImg" alt="Slide Image"
                            style="height:100%; width:100%; object-fit:contain;">
                        <template v-else>
                            <input type="file" id="upload-chart-img" accept="image/png, image/jpeg, image/jpg" hidden
                                @change="(e) => onImageChange(e, 'orgChartImg')">
                            <label for="upload-chart-img"
                                class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                style="cursor:pointer;">
                                <i class="material-symbols-outlined">upload</i>
                                <span>Upload Photo</span>
                            </label>
                        </template>
                    </div>
                    <button @click="resetImage('orgChartImg')" type="button"
                        class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                        Remove Photo
                    </button>
                </div>
            </div>
        </form>
        <div class="px-3">
            <button type="submit" form="thecompany" class="vmc-bg-prime-4 border-0 rounded text-white px-3 mt-4 py-1">
                Save All Changes
            </button>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';
export default {
    name: "TheCompanyCMS",
    components: {
        ToastCMS
    },
    data() {
        return {
            /* Text fields — named to match backend keys */
            TCdescription: '',
            whyVeritas: '',
            qualityCrewRecruitment: '',
            missionStatement: '',
            coreValuesHonesty: '',
            coreValuesIntegrity: '',
            coreValuesQualityService: '',
            history: '',

            /* Image fields — keys match backend flat fields */
            images: {
                aboutOfficeLogo: null,
                aboutQualityCrewBg: null,
                aboutTowerImg: null,
                orgChartImg: null
            },

            /* Snapshots for hasChanges */
            originalTCdescription: '',
            originalWhyVeritas: '',
            originalQualityCrewRecruitment: '',
            originalMissionStatement: '',
            originalCoreValuesHonesty: '',
            originalCoreValuesIntegrity: '',
            originalCoreValuesQualityService: '',
            originalHistory: '',
            originalImages: {
                aboutOfficeLogo: null,
                aboutQualityCrewBg: null,
                aboutTowerImg: null,
                orgChartImg: null
            },

            previewImages: [],
            showPreviewModal: false,
            currentPreviewIndex: 0,
        }
    },
    methods: {
        clearText() {
            const isEmpty =
                (!this.TCdescription || this.TCdescription.trim() === "") &&
                (!this.whyVeritas || this.whyVeritas.trim() === "") &&
                (!this.qualityCrewRecruitment || this.qualityCrewRecruitment.trim() === "") &&
                (!this.missionStatement || this.missionStatement.trim() === "") &&
                (!this.coreValuesHonesty || this.coreValuesHonesty.trim() === "") &&
                (!this.coreValuesIntegrity || this.coreValuesIntegrity.trim() === "") &&
                (!this.coreValuesQualityService || this.coreValuesQualityService.trim() === "") &&
                (!this.history || this.history.trim() === "");

            this.TCdescription = "";
            this.whyVeritas = "";
            this.qualityCrewRecruitment = "";
            this.missionStatement = "";
            this.coreValuesHonesty = "";
            this.coreValuesIntegrity = "";
            this.coreValuesQualityService = "";
            this.history = "";

            if (isEmpty) {
                this.$refs.toast.showToast(`Has no input`, "warning");
            } else {
                this.$refs.toast.showToast(`Cleared All Inputs`, "error");
            }
        },

        async onImageChange(event, key) {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('/vmc/api/upload', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                },
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                this.$set(this.images, key, data.url);
                this.$refs.toast.showToast(`Image attached`, "success");
            } else {
                console.error("Upload failed:", data.message);
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    }
    event.target.value = "";
},

        resetImage(key) {
            if (!this.images[key]) {
                this.$refs.toast.showToast('No image attached', "warning");
                return;
            }
            this.$set(this.images, key, null);
            const inputMap = {
                aboutOfficeLogo: 'upload-companylogo-img',
                aboutQualityCrewBg: 'upload-qualitycrew-img',
                aboutTowerImg: 'upload-history-img',
                orgChartImg: 'upload-chart-img'
            };
            const input = document.getElementById(inputMap[key]);
            if (input) input.value = "";
            this.$refs.toast.showToast('Image removed', "error");
        },

        previewImage(key) {
            if (!this.images[key]) {
                this.$refs.toast.showToast('No images to view', "warning");
                return;
            }
            this.previewImages = [this.images[key]];
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        onKeyboard(e) {
            if (this.showPreviewModal && e.key === 'Escape') {
                this.showPreviewModal = false;
            }
        },

        closePreviewImage() {
            this.showPreviewModal = false;
            this.previewImages = [];
        },

        async loadFormData() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Failed to fetch content");

                const data = await response.json();

                if (data && Object.keys(data).length > 0) {
                    this.TCdescription = data.TCdescription ?? '';
                    this.whyVeritas = data.whyVeritas ?? '';
                    this.qualityCrewRecruitment = data.qualityCrewRecruitment ?? '';
                    this.missionStatement = data.missionStatement ?? '';
                    this.coreValuesHonesty = data.coreValuesHonesty ?? '';
                    this.coreValuesIntegrity = data.coreValuesIntegrity ?? '';
                    this.coreValuesQualityService = data.coreValuesQualityService ?? '';
                    this.history = data.history ?? '';

                    this.$set(this.images, 'aboutOfficeLogo', data.aboutOfficeLogo ?? null);
                    this.$set(this.images, 'aboutQualityCrewBg', data.aboutQualityCrewBg ?? null);
                    this.$set(this.images, 'aboutTowerImg', data.aboutTowerImg ?? null);
                    this.$set(this.images, 'orgChartImg', data.orgChartImg ?? null);
                }

                // Snapshots
                this.originalTCdescription = this.TCdescription;
                this.originalWhyVeritas = this.whyVeritas;
                this.originalQualityCrewRecruitment = this.qualityCrewRecruitment;
                this.originalMissionStatement = this.missionStatement;
                this.originalCoreValuesHonesty = this.coreValuesHonesty;
                this.originalCoreValuesIntegrity = this.coreValuesIntegrity;
                this.originalCoreValuesQualityService = this.coreValuesQualityService;
                this.originalHistory = this.history;
                this.originalImages = JSON.parse(JSON.stringify(this.images));

            } catch (error) {
                console.error("Load error:", error);
                this.$refs.toast.showToast("Failed to load data!", "error");
            }
        },

        async saveAllChanges(e) {
            e.preventDefault();

            if (!this.hasChanges) {
                this.$refs.toast.showToast("Nothing to save", "warning");
                return;
            }

            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        TCdescription: this.TCdescription,
                        whyVeritas: this.whyVeritas,
                        qualityCrewRecruitment: this.qualityCrewRecruitment,
                        missionStatement: this.missionStatement,
                        coreValuesHonesty: this.coreValuesHonesty,
                        coreValuesIntegrity: this.coreValuesIntegrity,
                        coreValuesQualityService: this.coreValuesQualityService,
                        history: this.history,
                        aboutOfficeLogo: this.images.aboutOfficeLogo,
                        aboutQualityCrewBg: this.images.aboutQualityCrewBg,
                        aboutTowerImg: this.images.aboutTowerImg,
                        orgChartImg: this.images.orgChartImg
                    })
                });

                if (!response.ok) throw new Error("Server error");

                // Update snapshots
                this.originalTCdescription = this.TCdescription;
                this.originalWhyVeritas = this.whyVeritas;
                this.originalQualityCrewRecruitment = this.qualityCrewRecruitment;
                this.originalMissionStatement = this.missionStatement;
                this.originalCoreValuesHonesty = this.coreValuesHonesty;
                this.originalCoreValuesIntegrity = this.coreValuesIntegrity;
                this.originalCoreValuesQualityService = this.coreValuesQualityService;
                this.originalHistory = this.history;
                this.originalImages = JSON.parse(JSON.stringify(this.images));

                this.$refs.toast.showToast("Saved all changes.", "success");
                setTimeout(() => { window.location.reload(); }, 1500);

            } catch (error) {
                console.error("Save error:", error);
                this.$refs.toast.showToast("Save failed. Check your connection.", "error");
            }
        }
    },

    async mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        await this.loadFormData();
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
    },

    computed: {
        hasChanges() {
            return (
                this.TCdescription !== this.originalTCdescription ||
                this.whyVeritas !== this.originalWhyVeritas ||
                this.qualityCrewRecruitment !== this.originalQualityCrewRecruitment ||
                this.missionStatement !== this.originalMissionStatement ||
                this.coreValuesHonesty !== this.originalCoreValuesHonesty ||
                this.coreValuesIntegrity !== this.originalCoreValuesIntegrity ||
                this.coreValuesQualityService !== this.originalCoreValuesQualityService ||
                this.history !== this.originalHistory ||
                JSON.stringify(this.images) !== JSON.stringify(this.originalImages)
            );
        }
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
    z-index: 9999;
}

hr {
    border-top: 1px solid black;
}

.sticky-controls {
    position: sticky;
    z-index: 1;
    background-color: white;
}

@media (min-width: 330px) {
    .company-header {
        padding: 15px 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .desc-header {
        font-size: 17px;
        font-weight: 600;
    }

    textarea {
        font-size: 15px;
        outline: none;
        resize: none;
    }

    .grid {
        gap: 20px;
    }

    .preview-modal {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        overflow-y: hidden;
        overscroll-behavior: contain;
    }

    .modal-content img {
        max-width: 70vw;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }

    .close-btn {
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
    }

    .modal-content img {
        max-height: 80vh;
    }
}

@media (min-width: 768px) {
    .desc-header {
        font-size: 20px;
    }
}

@media (min-width: 992px) {}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 82px;
    }

    .sticky-controls {
        top: 82px;
    }
}
</style>